/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'newsletter',
		'mailingLists',
		'mailingListTrees'
	],

	config: {
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'newsletter',
				'mailingLists',
				'selectMailingListTree'
			]
		}
	},

	actions: {
		addTree: {
			source: {
				load: {
					componentData: {
						config: {
							lastMileSelector: 'section.filterContent section.colWrap'
						}
					}
				}
			}
		}
	},

	methods: {
		preSelectEntities: function(entities){
			var indexes = [];
			for(var i in entities){
				indexes.push(this.getNodeIndex(entities[i], 'mailinglist'));
			}
			this.checkNodes(indexes, Object.keys(this.model.states.trees).shift(), true);
		},

		onTreeAction: function (data) {
			var self = this;

			switch (data.onTreeActionOptions.eventType) {
				case 'changed.jstree':
					if(!data.onTreeActionOptions.autoSelect || (this.config.decisionOptions && this.config.decisionOptions.decideOnAutoSelect)) {
						var allNodes = self.registry[0].tree.resourceData.treeData.nodes;
						var checkedNodes = this.getCheckedNodes();
						self.model.dirtySelection = [];
						utils.forEach(allNodes, function(nodeData){
							if(utils.indexOf(checkedNodes, nodeData.index) > -1){
								self.model.dirtySelection.push(nodeData);
							}
						});

						// show page actions if necessary
						this.triggerClosest('onDecision', {
							decisionComponent: self,
							decisionType: 'submit',
							decisionOptions: self.config.decisionOptions || {},
							data: self.model.dirtySelection
						});
					}
					break;
			}
		},

		onAttachDone: function(){
			// NOTE: prevent subActions from being appended
			// select dirty assigned mailingLists if necessary
			if(this.resourceData.dirtyAssignedMailingLists){
				var self = this;
				this.treesReady(function(){
					self.preSelectEntities(self.resourceData.dirtyAssignedMailingLists);
				});
			}
		}
	},

	// NOTE: prevent mailingListTrees handlers from being called for this selectMailingListTrees-Component
	handlers: undefined
};
